import { Phone } from 'lucide-react';
import { useContact } from '@/features/settings/useSiteSettings';

export const CallBar = () => {
  const contact = useContact();

  return (
    <a href={contact.phoneHref} className="fixed inset-x-0 bottom-0 z-50 flex min-h-14 items-center justify-center gap-3 bg-navy font-display text-lg font-bold text-cream no-underline sm:hidden">
      <Phone className="size-5" aria-hidden="true" />
      Hívás: {contact.phone}
    </a>
  );
};
